import React from 'react';
import { SuCarousel, TopicCard } from '@amzn/seller-university-ui-components';
import useUserMetrics from 'src/metrics/useUserMetrics';
import { FeatureName } from 'src/metrics/metricsFields';

/** Topic card props */
interface TopicCardProps {
  id: string;
  title: string;
  description: string;
  thumbnailLink: string;
  buttonProps: {
    children: string;
    label: string;
    onClick: () => void;
  };
}

/** TopicsCarousel props */
interface TopicsCarouselProps {
  topics: TopicCardProps[];
}

const TopicsCarousel: React.FC<TopicsCarouselProps> = ({ topics }) => {
  const { clickMetric } = useUserMetrics();

  return (
    <SuCarousel
      items={topics}
      getItemKey={(topic) => topic.id}
      renderItem={(topic) => (
        <TopicCard
          title={topic.title}
          description={topic.description}
          thumbnailLink={topic.thumbnailLink}
          buttonProps={{
            ...topic.buttonProps,
            onClick: () => {
              clickMetric({
                feature: FeatureName.TopicPage,
                metadata: {
                  url: window.location.href,
                  topicId: topic.id,
                  topicTitle: topic.title,
                },
              });
              topic.buttonProps.onClick();
            },
          }}
          className="h-full"
        />
      )}
      layout={{
        xsmall: { cols: 1, rows: 1 },
        small: { cols: 2, rows: 1 },
        medium: { cols: 2, rows: 1 },
        large: { cols: 3, rows: 2 },
      }}
      className="mx-[-40px] px-su-space-06"
    />
  );
};

export default TopicsCarousel;
